import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchCountryList } from "../../../slices/LocationSlice/countrySlice"; // Adjust path as needed
import api from "../../../auth/api";
import {fetchPageHeaderData} from '../../../slices/panelSlice/pageHeaderSlice'
import { alertSuccess, alertError } from "../../../components/Alert";


const AddPageHeader = () => {

    const dispatch = useDispatch();
    const { countryList, loading, error } = useSelector((state) => state.countryList);

  // Fetch country list when the component mounts
  useEffect(() => {
    dispatch(fetchCountryList());
  }, [dispatch]);

  const [formData, setFormData] = useState({
    title: "",
    country: "",
    pageNo: "",
    icon_0: null,
    icon_1: null,
    icon_2: null,
    translate:null
  });

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (files) {
      setFormData({ ...formData, [name]: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    console.log(formData)
    setFormData((prev)=>({
        ...prev,
        translate:JSON.stringify({'English':prev.title})
    }))

    let finalData = {
      ...formData,
      translate:JSON.stringify({'English':formData.title})
    }
    try{
        const resp = await api.post('/panel/pageHeader',finalData, {
          headers: {
            'Content-Type': 'multipart/form-data', // Required for file uploads
          },
        });
        console.log(resp)
        alertSuccess('Page header successfully added.')
        dispatch(fetchPageHeaderData())

      }catch(err){
        console.log(err)
        alertError(err?.response?.data?.errors)
      }
  };

  return (
    <div className="bg-gray-100 flex items-center justify-center w-full">
      <form
        onSubmit={handleSubmit}
        className="bg-white p-6 rounded-lg shadow-lg w-full"
      >
        {/* <h2 className="text-2xl font-bold mb-4">Add Page Header</h2> */}

        <div className="flex gap-3 justify-between">
        {/* Title */}
        <div className="mb-4">
          <label htmlFor="title"  className="block text-sm font-medium text-gray-700">
            Title
          </label>
          <input
            type="text"
            required
            id="title"
            name="title"
            value={formData.title}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
            placeholder="Enter title"
          />
        </div>

        {/* Country */}
        <div className="mb-4">
          <label htmlFor="country" className="block text-sm font-medium text-gray-700">
            Country
          </label>
          <select value={formData.country} required name="country" onChange={handleChange} className="w-48 mt-1 p-2  border rounded-md focus:ring-2 focus:ring-blue-500 outline-none">
            <option value="" disabled selected>Select Country</option>
                    {countryList.result?.map(m=>{
                        return <option value={m.id}>{m.title}</option>
                    })}
          </select>
          {/* <input
            type="text"
            id="country"
            name="country"
            value={formData.country}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
            placeholder="Enter country"
          /> */}
        </div>

        {/* Page Number */}
        <div className="mb-4">
          <label htmlFor="pageNo" className="block text-sm font-medium text-gray-700">
            Page Number
          </label>
          <input
            type="number"
            id="pageNo"
            name="pageNo"
            required
            value={formData.pageNo}
            onChange={handleChange}
            className="mt-1 p-2 w-full border rounded-md focus:ring-2 focus:ring-blue-500 outline-none"
            placeholder="Enter page number"
          />
        </div>
        </div>

    <div className="flex justify-between mt-6">


        {/* Male Image */}
        <div className="mb-4">
          <label htmlFor="male" className="block text-sm font-medium text-gray-700">
            Male Image
          </label>
          <input
            type="file"
            id="male"
            name="icon_1"
            onChange={handleChange}
            className="mt-1 block w-full text-sm text-gray-500
                       file:mr-4 file:py-2 file:px-4
                       file:rounded-md file:border
                       file:text-sm file:font-semibold
                       file:bg-blue-50 file:text-blue-700
                       hover:file:bg-blue-100"
          />
        </div>

        {/* Female Image */}
        <div className="mb-4">
          <label htmlFor="female" className="block text-sm font-medium text-gray-700">
            Female Image
          </label>
          <input
            type="file"
            id="female"
            name="icon_2"
            onChange={handleChange}
            className="mt-1 block w-full text-sm text-gray-500
                       file:mr-4 file:py-2 file:px-4
                       file:rounded-md file:border
                       file:text-sm file:font-semibold
                       file:bg-blue-50 file:text-blue-700
                       hover:file:bg-blue-100"
          />
        </div>

        {/* Default Image */}
        <div className="mb-4">
          <label htmlFor="defaultImage" className="block text-sm font-medium text-gray-700">
            Default Image
          </label>
          <input
            type="file"
            id="defaultImage"
            name="icon_0"
            required
            onChange={handleChange}
            className="mt-1 block w-full text-sm text-gray-500
                       file:mr-4 file:py-2 file:px-4
                       file:rounded-md file:border
                       file:text-sm file:font-semibold
                       file:bg-blue-50 file:text-blue-700
                       hover:file:bg-blue-100"
          />
        </div>

        </div>

        {/* Submit Button */}
        <button
          type="submit"
          className="w-full bg-[var(--mainColLight)] text-white py-2 px-4 rounded-md"
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default AddPageHeader;
